import { render, staticRenderFns } from "./BroadcastingRights.vue?vue&type=template&id=418e8d13&scoped=true&"
import script from "./BroadcastingRights.vue?vue&type=script&lang=js&"
export * from "./BroadcastingRights.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastingRights.vue?vue&type=style&index=0&id=418e8d13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418e8d13",
  null
  
)

export default component.exports